import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";
import { IContract, IStore, IIdName, IIdNameGeneric } from '../../../_entities';
import { StringTool } from "../../../core/tools/index";
import * as moment from 'moment';

@Component({
	selector: 'e-tax-other-costs--actual-amounts',
	template: require('./e-tax-other-costs--actual-amounts.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class TaxOtherCostsComponent
	extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) { super(contractService); }

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/e-tax-other-costs--actual-amounts.component.ts